import { Flex, Text, HStack, Icon, useColorModeValue } from '@chakra-ui/react';

import Card from 'components/card/Card';

import DropzoneCard from 'components/dropzone/DropzoneCard';

import { MdCheckCircle } from 'react-icons/md';

const EnhancedDropzone = ({
  title,
  handleFileUpload,
  isLoading,
  isComplete,
  fileCount = 0,
  required = false,
}: {
  title: string;
  handleFileUpload: (files: any) => void;
  isLoading: boolean;
  isComplete: boolean;
  fileCount?: number;
  required?: boolean;
}) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const successColor = useColorModeValue('green.500', 'green.400');

  // Pre-compute all color variations to avoid conditional hooks
  const borderColorComplete = useColorModeValue('green.300', 'green.500');
  const borderColorDefault = useColorModeValue('gray.200', 'whiteAlpha.100');
  const bgColorComplete = useColorModeValue(
    'green.50',
    'rgba(48, 208, 88, 0.08)',
  );
  const bgColorDefault = useColorModeValue('gray.50', 'navy.700');

  // Then use the computed values conditionally
  const borderColor = isComplete ? borderColorComplete : borderColorDefault;
  const bgColor = isComplete ? bgColorComplete : bgColorDefault;

  return (
    <Card
      p="10px"
      borderColor={borderColor}
      bg={bgColor}
      boxShadow={isComplete ? '0 0 0 1px green' : 'none'}
    >
      <Flex direction="column" h="100%">
        <Flex justify="space-between" align="center" mb="8px">
          <Text color={textColor} fontSize="md" fontWeight="600">
            {title}{' '}
            {required && (
              <Text as="span" color="red.500">
                *
              </Text>
            )}
          </Text>
          {isComplete && (
            <HStack spacing={1}>
              <Icon as={MdCheckCircle} color={successColor} />
              <Text fontSize="xs" color={successColor} fontWeight="500">
                {fileCount > 1 ? `${fileCount} files` : 'Uploaded'}
              </Text>
            </HStack>
          )}
        </Flex>
        <DropzoneCard
          handleFileUpload={handleFileUpload}
          isLoading={isLoading}
        />
      </Flex>
    </Card>
  );
};

export default EnhancedDropzone;
